import { User, Home, Car } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

export function ComparisonSection() {
  const navigate = useNavigate();
  const loanTypes = [
    {
      title: "Personal Loan Comparison",
      description:
        "Compare personal loan offers from multiple banks to find the lowest EMI and best terms for your needs.",
      icon: <User className="h-6 w-6 text-[#59266D] md:h-8 md:w-8" />,
      naviLinks: "/best-personal-loan-offer",
    },
    {
      title: "Home Loan Comparison",
      description:
        "Find the best home loan rates and terms to make your dream home more affordable.",
      icon: <Home className="h-6 w-6 text-[#59266D] md:h-8 md:w-8" />,
      naviLinks: "/best-home-loan-offer",
    },
    {
      title: "Car Loan Comparison",
      description:
        "Compare car loan options to get on the road with the most favorable financing terms.",
      icon: <Car className="h-6 w-6 text-[#59266D] md:h-8 md:w-8" />,
      naviLinks: "/best-car-loan-offer",
    },
  ];

  return (
    <section id="compare-loan-offer" className="bg-[#EBE8FC] py-10 md:py-16">
      <div className="container px-3 px-md-6">
        <h2 className="mb-3 md:mb-8 text-center text-[1.3rem] md:text-2xl lg:text-3xl font-bold tracking-wide px-2">
          Compare Bank Offers for Every Loan Type
        </h2>

        {/* Subheading to establish relationship */}
        <p className="mb-6 text-center text-[0.9rem] tracking-wide text-gray-600 md:text-base">
          Find the perfect loan for your specific needs:
        </p>

        <div className="grid grid-cols-1 gap-4 md:gap-6 md:grid-cols-3 ">
          {loanTypes.map((loanType, index) => (
            <div
              key={index}
              className="rounded-[24px] bg-white border border-gray-200 p-4 md:p-6"
            >
              <div className="mb-3 bg-white p-2 inline-flex items-center justify-center rounded-[16px] w-10 h-10 md:w-12 md:h-12">
                {loanType.icon}
              </div>
              <h3 className="mb-2 text-[17px] text-start md:text-lg font-semibold">
                {loanType.title}
              </h3>
              <p className="mb-4 text-gray-600 text-[15px] md:text-sm text-start">
                {loanType.description}
              </p>
              <button
                className="w-full rounded-full text-sm md:text-sm bg-[#59266D] text-white py-[0.7rem] px-4  hover:bg-[#59266D]/90 transition-colors duration-200"
                type="button"
                onClick={() => {
                  navigate(loanType.naviLinks);
                }}
              >
                Compare Now
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
